import { Component, OnInit } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

import { AuthenticationService } from '@/services/authentication.service'
import { MerchantsService } from '@/services/merchants.service'
import { SellersService } from '@/services/sellers.service'

import { Merchant } from '@/domain/merchant'
import { Seller } from '@/domain/seller'

@UntilDestroy()
@Component({
  selector: 'settings-view',
  templateUrl: 'settings-view.component.html'
})
export class SettingsViewComponent implements OnInit {

  seller: Seller = null
  merchant: Merchant = null

  constructor(
    public auth: AuthenticationService,
    private _sellersService: SellersService,
    private _merchantsService: MerchantsService
  ) { }

  ngOnInit(): void {
    if (this.auth.isSeller) {
      const sellerId = this.auth.sellerId
      if (sellerId) {
        this.loadSellerData(sellerId)
      }
    }
    if (this.auth.isMerchant) {
      this._merchantsService.currentMerchant.pipe(untilDestroyed(this)).subscribe(
        merchant => { this.merchant = merchant }
      )
    }
  }

  private loadSellerData(sellerId: number): void {
    this._sellersService.get(sellerId).subscribe(
      seller => {
        this.seller = seller
      },
      error => { }
    )
  }
}